import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
  booleanAttribute,
} from '@angular/core';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [NgClass],
  templateUrl: './button.html',
  styleUrls: ['./button.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Button {
  @Input({ alias: 'inputClass' }) inputClass: string = '';
  @Input({ alias: 'buttonDisabled' })
  buttonDisabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Output() readonly buttonClick = new EventEmitter<void>();

  onButtonClick(): void {
    if (this.loading || this.buttonDisabled) {
      return;
    }
    this.buttonClick.emit();
  }
}
